import type { WorkspaceUser } from '../../../../stores/authStore';

export function getPsTokensPurchaseContext(authUser: WorkspaceUser | null): {
  workspaceId: string | null;
  canPurchase: boolean;
} {
  const workspaceId = authUser?.currentWorkspace?.workspace_id ?? null;
  const createdBy = authUser?.currentWorkspace?.workspaces?.created_by;
  const userId = authUser?.id;
  const isAdmin = authUser?.currentWorkspace?.role?.name === 'admin';

  const canPurchase = Boolean(
    workspaceId && userId && isAdmin && createdBy === userId,
  );

  return { workspaceId, canPurchase };
}
